import React, { useState } from 'react';

import { Field, FieldArray, FormikValues } from 'formik';

import Button from '@mui/material/Button';
import { default as ListItem } from '@mui/material/ListItem';
import { default as ListItemText } from '@mui/material/ListItemText';
import { Collapse } from '@mui/material';
import { default as IconButton } from '@mui/material/IconButton';
import { default as ExpandLess } from '@mui/icons-material/ExpandLess';
import { default as ExpandMore } from '@mui/icons-material/ExpandMore';
import CloseIcon from '@mui/icons-material/Close';

import TranslationHelper from '../../helpers/TranslationHelper';

import { APPLICATION_ITEMS } from '../../constants/dictionaries/ExternalApplicationItems';
import { DIGITS_ONLY_REGEX } from '../../constants/regex';

import NumberFieldWrapper from '../common/formikWrappers/NumberFieldWrapper';
import FieldWrapper from '../common/formikWrappers/FieldWrapper';
import { useStyles } from './Themable.hooks';
import { renderMenuItems } from '../../helpers/renderMenuItems';

const CONDITIONS_MAX_LENGTH = 5;

interface IOwnProps {
    values: FormikValues;
    errors: Array<{ appName: string; externalId: string }>;
}
const ExternalLinkages = ({ values, errors }: IOwnProps) => {
    const classes = useStyles();
    const [open, setOpen] = useState(true);

    const handleExpandClick = () => {
        setOpen(!open);
    };
    return (
        <>
            <ListItem disableGutters={true} className={classes.listItemHeading}>
                <ListItemText
                    primary={TranslationHelper.translate('Linkages')}
                    className={classes.heading}
                />
                <IconButton onClick={handleExpandClick}>
                    {open ? <ExpandLess /> : <ExpandMore />}
                </IconButton>
            </ListItem>
            <Collapse in={open} timeout="auto" unmountOnExit={true}>
                <FieldArray
                    name="data.externalLinkages"
                    validateOnChange={false}
                >
                    {({ remove, push }) => {
                        return (
                            <div className={classes.linkagesContainer}>
                                {values?.map(
                                    (
                                        value: {
                                            appName: string;
                                            externalId: string;
                                        },
                                        index: number
                                    ) => (
                                        <div
                                            className={classes.linkage}
                                            key={index}
                                        >
                                            <Field
                                                name={`data.externalLinkages.${index}.appName`}
                                                component={FieldWrapper}
                                                label={TranslationHelper.translate(
                                                    'linkage.application'
                                                )}
                                                required={true}
                                                error={
                                                    !!errors?.[index]?.appName
                                                }
                                                helperText={
                                                    errors?.[index]?.appName
                                                }
                                                select={true}
                                                className={classes.fieldSm}
                                            >
                                                {renderMenuItems(
                                                    APPLICATION_ITEMS,
                                                    (item) => item
                                                )}
                                            </Field>
                                            <Field
                                                name={`data.externalLinkages.${index}.externalId`}
                                                component={NumberFieldWrapper}
                                                regex={DIGITS_ONLY_REGEX}
                                                fullWidth={true}
                                                label={TranslationHelper.translate(
                                                    'linkage.identificator'
                                                )}
                                                required={true}
                                                error={
                                                    !!errors?.[index]
                                                        ?.externalId
                                                }
                                                helperText={
                                                    errors?.[index]?.externalId
                                                }
                                                className={classes.fieldMd}
                                            />
                                            <IconButton
                                                aria-label="close"
                                                onClick={() => {
                                                    remove(index);
                                                }}
                                            >
                                                <CloseIcon />
                                            </IconButton>
                                        </div>
                                    )
                                )}
                                <Button
                                    type="button"
                                    variant="contained"
                                    color="primary"
                                    disabled={
                                        values?.length >= CONDITIONS_MAX_LENGTH
                                    }
                                    onClick={() => {
                                        push({
                                            appName: APPLICATION_ITEMS[0].id,
                                            externalId: '',
                                        });
                                    }}
                                >
                                    {TranslationHelper.translate('Add linkage')}
                                </Button>
                            </div>
                        );
                    }}
                </FieldArray>
            </Collapse>
        </>
    );
};
export default ExternalLinkages;
